if (window['kabernetContext'] && window['kabernetContext'].frontRelativeUrl) {
  __webpack_public_path__ = urlJoin(window['kabernetContext'].frontRelativeUrl, __webpack_public_path__);
}
if (!__webpack_public_path__ || __webpack_public_path__.length === 0) {
  __webpack_public_path__ = '/app/';
}

import { createApp } from 'vue';
import VueSocialSharing from 'vue-social-sharing';
import VueProgressBar from './shared/components/ProgressBar';
import DatePicker from 'vue2-datepicker';
import VueLazyloadNext from 'vue-lazyload-next';
import vClickOutside from 'click-outside-vue3';
import { createHead, Head } from '@vueuse/head';

import App from './App.vue';
import getRouter from './router';
import store from './store';
import globals from './globals';

import { formatNumber, formatCurrency, formatDate, formatCash, formatTimeAgo } from '@/shared/filters';
import { i18n } from './i18n';
import { urlJoin } from './shared/helpers/urlJoin';

DatePicker.locale('cs', {
  formatLocale: {
    months: ['január', 'február', 'marec', 'apríl', 'máj', 'jún', 'júl', 'august', 'september', 'október', 'november', 'december'],
    monthsShort: ['jan', 'feb', 'mar', 'apr', 'máj', 'jún', 'júl', 'aug', 'sep', 'okt', 'nov', 'dec'],
    weekdays: ['nedeľa', 'pondelok', 'utorok', 'streda', 'štvrtok', 'piatok', 'sobota'],
    weekdaysShort: ['ne', 'po', 'ut', 'st', 'št', 'pi', 'so'],
    weekdaysMin: ['ne', 'po', 'ut', 'st', 'št', 'pi', 'so'],
    firstDayOfWeek: 1,
    firstWeekContainsDate: 4,
  },
  yearFormat: 'YYYY',
  monthFormat: 'MMM',
  monthBeforeYear: true,
});

const appElementId = 'app';
const appElement = document.getElementById('app');
const dataRouter = appElement?.getAttribute('data-router') == 'true';
const app = createApp({}, { router: dataRouter });
const head = createHead();
app.component('Head', Head);
app.component('easy-app', App);
app.component('easy-registration', globals.components.Registration);
app.component('easy-login-form', globals.components.LoginForm);
app.component('easy-ad-search-home', globals.components.AdSearchHome);

app.use(head);
app.use(i18n);
app.use(VueSocialSharing);
app.use(vClickOutside);
app.use(DatePicker);
app.use(VueLazyloadNext);
app.use(VueProgressBar, {
  thickness: '5px',
  autoFinish: false,
});
app.use(store);

const router = getRouter(dataRouter);

app.use(router);

app.config.globalProperties.$filters = {
  number: formatNumber,
  currency: formatCurrency,
  date: formatDate,
  cash: formatCash,
  timeAgo: formatTimeAgo,
};

store.dispatch('initApp').then(startVue);

function startVue() {
  app.mount(`#${appElementId}`);
}

export { app, router };
